import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { SrxApi } from '../api/SrxApi';

export const resolveRequestedActionInternalId = (alert, widget) => {
    if (widget === 'AdmissionMeds') return alert?.admissionMedsGroupID;
    if (widget === 'highcostalerts') return alert?.highCostAlertsId ?? alert?._internalID;
    return alert?._internalID;
};

export const getModalToggleForAction = (action, toggles) => {
    const actionLower = action?.toLowerCase();
    if (actionLower === 'approve' || actionLower === 'limitedapproval' || actionLower === 'deny' || actionLower === 'approveonce') {
        return toggles.toggleCommentModal();
    }
    if (actionLower === 'ask') return toggles.toggleQuestionModal();
    if (actionLower === 'submitlimit') return toggles.toggleLimitedApprovalModal();
    if (actionLower === 'send') return toggles.toggleSendModal();
    if (actionLower === 'donotsend') return toggles.toggleDoNotSendModal();
    return undefined;
};

export const buildSubmittedActionMessage = ({ action, actionComment, user, res }) => {
    const now = new Date().toISOString();
    const responseAction = res?.data?.requestedAction || res?.data?.action || res?.data?.requestAction;

    if (responseAction && typeof responseAction === 'object') {
        return {
            ...responseAction,
            action: responseAction.action || action,
            actionComment: responseAction.actionComment ?? actionComment,
            requestedBy: responseAction.requestedBy || user?.displayName || user?.email,
            sentTime: responseAction.sentTime || responseAction.sent_time || responseAction.loggedAt || now,
        };
    }

    return {
        requestActionID: res?.data?.requestActionID || `pending-${Date.now()}`,
        action,
        actionComment,
        requestedBy: user?.displayName || user?.email,
        sentTime: now,
        loggedAt: now,
        readByFaci: true,
    };
};

export const submitUserAction = async ({
    action,
    actionComment,
    widget,
    limitDays = null,
    username = null,
    alert,
    user,
    setUser,
    setLoadingUserAction,
    setActionComment,
    toggleCommentModal,
    toggleQuestionModal,
    toggleLimitedApprovalModal,
    toggleSendModal,
    toggleDoNotSendModal,
    onActionSubmitted,
}) => {
    const id = resolveRequestedActionInternalId(alert, widget);

    const widgetName = widget === 'alfNewScript' ? 'alfNewScriptNeeded' : widget;

    const payload = {
        requestedAction: action,
        widget: widgetName,
        _internalID: id,
        _internalUUID: alert?.id,
        rxNo: alert?.rxNo,
        actionComment,
    };

    if (action?.toLowerCase() === 'submitlimit') payload.limitDays = limitDays;
    if (username) payload.username = username;

    setLoadingUserAction(true);

    const sendUserActionToast = toast.loading('Processing user action...', {
        theme: 'light',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });

    try {
        const res = await SrxApi.post('/requestaction', payload);

        setActionComment('');
        toast.update(sendUserActionToast, {
            render: res?.data?.message,
            type: 'success',
            isLoading: false,
            autoClose: 3000,
            hideProgressBar: null,
            closeOnClick: null,
        });

        if (onActionSubmitted) {
            onActionSubmitted(buildSubmittedActionMessage({ action, actionComment, user, res }));
        }

        getModalToggleForAction(action, {
            toggleCommentModal,
            toggleQuestionModal,
            toggleLimitedApprovalModal,
            toggleSendModal,
            toggleDoNotSendModal,
        });
    } catch (err) {
        if (err?.response?.status === 400 && err?.response?.data?.Errors === 'Missing Mediprocity credentials') {
            setUser({
                ...user,
                mediprocityUser: null,
                mediprocityInfo: {},
            });

            toast.update(sendUserActionToast, {
                render: (
                    <div>
                        SpecialtyRx Now credentials required.{' '}
                        <Link to="/settings/specialtyRxNow" style={{ color: '#fff', textDecoration: 'underline' }}>
                            Set your credentials
                        </Link>
                    </div>
                ),
                type: 'error',
                isLoading: false,
                autoClose: 8000,
                hideProgressBar: null,
                closeOnClick: null,
            });
        } else {
            toast.update(sendUserActionToast, {
                render: 'Error sending user action',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
                hideProgressBar: null,
                closeOnClick: null,
            });
        }
    } finally {
        setLoadingUserAction(false);
    }
};

